import React from "react";

const getPublishStatus = (is_published) => {
  const value = Number(is_published);
  return value === 1 ? "Published" : "Draft";
};

/**
 * Returns columns for Appraisal Setup list (DataTable component).
 * Plain factory — do not use hooks here (called from parent useMemo).
 */
const Columns = ({ getCampaignsName, getDesignationsName, getActions }) => [
  { id: "title", header: "Title", accessor: "title", sortable: true, searchable: true },
  {
    id: "office",
    header: "Office",
    accessor: (row) =>
      row.office_name != null && row.office_name !== ""
        ? row.office_name
        : row.office?.name ?? "",
    sortable: true,
    searchable: true,
  },
  {
    id: "campaigns",
    header: "Campaign",
    accessor: (row) => getCampaignsName(row.campaigns),
    sortable: false,
    searchable: true,
  },
  {
    id: "designations",
    header: "Designation",
    accessor: (row) => getDesignationsName(row.designations),
    sortable: false,
    searchable: true,
  },
  {
    id: "status",
    header: "Status",
    accessor: (row) => getPublishStatus(row.is_published),
    cell: (value) => (
      <span
        className={`font-13 font-weight-s-bold ${
          value === "Published" ? "text-success" : "text-warning"
        }`}
      >
        {value}
      </span>
    ),
    sortable: true,
    searchable: true,
  },
  {
    id: "actions",
    header: "Actions",
    accessor: null,
    cell: (_, row) => getActions(row),
    sortable: false,
    searchable: false,
  },
];

export default Columns;
